import React, { Component } from 'react';

const Progress = () => {
	return ( <h1>Track Progress</h1> );
}
 
export default Progress;